import React, { ReactNode } from 'react';
import { CSSTransition } from 'react-transition-group';
import { ActiveCallKey } from 'flow/types/EntityKeys';
import { twMerge } from 'tailwind-merge';

interface CallProps {
    children: ReactNode;
    isRemote: boolean;
    onEnter?: (node: ReactNode) => void;
    onExited?: () => void;
    callKey?: ActiveCallKey;
    enter?: boolean;
    exit?: boolean;
    hidden?: boolean;
}

export const CallTransition = ({
    children,
    isRemote,
    onEnter,
    onExited,
    ...otherProps
}: CallProps) => (
    <CSSTransition
        classNames="flex"
        timeout={{
            appear: 300,
            enter: 300,
            exit: 2000,
        }}
        onEnter={onEnter}
        onExited={onExited}
        isRemote={isRemote}
        {...otherProps}
    >
        {children}
    </CSSTransition>
);

interface MeetingProps {
    children: ReactNode;
    onExited: () => void;
}

export const MeetingTransition = ({ children, onExited }: MeetingProps) => (
    <CSSTransition
        classNames="flex"
        timeout={{
            appear: 0,
            enter: 0,
            exit: 0,
        }}
        onExited={onExited}
    >
        {children}
    </CSSTransition>
);

interface Props {
    transitionIn?: boolean;
    onEnter?: (node: ReactNode) => void;
    onExited?: () => void;
    children?: ReactNode;
    timeout?: {
        appear?: number;
        enter: number;
        exit: number;
    };
    unmountOnExit?: boolean;
    id?: string;
    className?: string;
}

const CSSTransitionTW = ({
    onEnter,
    onExited,
    transitionIn,
    children,
    timeout,
    unmountOnExit,
    id,
    className,
}: Props) => {
    return (
        <CSSTransition
            className={twMerge('flex', className)}
            id={id}
            in={transitionIn}
            timeout={timeout}
            onEnter={onEnter}
            onExited={onExited}
            unmountOnExit={unmountOnExit}
        >
            {children}
        </CSSTransition>
    );
};

export const GenericCanvasTransition = ({
    onEnter,
    onExited,
    transitionIn,
    children,
    timeout,
    unmountOnExit,
}: Props) => {
    return (
        <CSSTransition
            classNames={{
                enter: 'animate-slideInDialpad',
                exit: 'animate-slideOut',
            }}
            in={transitionIn}
            timeout={timeout}
            onEnter={onEnter}
            onExited={onExited}
            unmountOnExit={unmountOnExit}
        >
            {children}
        </CSSTransition>
    );
};

export const DialpadTransition = ({
    onEnter,
    onExited,
    transitionIn,
    children,
    timeout,
    unmountOnExit,
}: Props) => {
    return (
        <CSSTransition
            classNames={{
                enter: 'animate-slideInDialpad',
                exit: 'animate-slideOut',
            }}
            in={transitionIn}
            timeout={timeout}
            onEnter={onEnter}
            onExited={onExited}
            unmountOnExit={unmountOnExit}
        >
            {children}
        </CSSTransition>
    );
};

export default CSSTransitionTW;
